/**
 * Header scroll — adiciona .is-scrolled ao #header-voanet ao rolar a página,
 * habilitando o efeito "glass" + sombra do header sticky. Sem dependências.
 */
(function () {
    function init() {
        var header = document.getElementById("header-voanet");
        if (!header) return;

        var ticking = false;
        function update() {
            var y = window.scrollY || window.pageYOffset || 0;
            header.classList.toggle("is-scrolled", y > 8);
            ticking = false;
        }
        function onScroll() {
            if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
        }
        window.addEventListener("scroll", onScroll, { passive: true });
        update();
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
